import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine2FontMdToSmBoldProps extends ITextBoxProps {
  bold?: boolean
}

export const TextBoxMaxLine2FontMdToSmBold = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.FontMdToSmBold,
  alignment = TextAligning.Left,
  maxLines = 2,
  ...rest
}: ITextBoxMaxLine2FontMdToSmBoldProps): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
